import * as React from "react";
import { Route } from 'react-router-dom';
import ServiceTypes from '~/components/ServiceTypes';

export default [
    <Route exact path="/service-types" component={ServiceTypes} />,
];